import { AlertTriangle, ChevronRight, User, Wrench } from 'lucide-react';

/**
 * Affiche une inspection chauffeur signalee avec defauts.
 * Deploiement detaille des defauts, notes generales, + bouton "Creer un bon" pre-rempli.
 */
const FlaggedInspectionCard = ({ inspection, onCreateWorkOrder, testIdPrefix = 'flagged' }) => {
  const items = Array.isArray(inspection?.items) ? inspection.items : [];
  const defects = items.filter((it) => it?.status === 'defect');
  const vehicleLabel = [
    inspection?.vehicle_unit && `#${inspection.vehicle_unit}`,
    inspection?.vehicle_plate,
    inspection?.vehicle_name,
  ].filter(Boolean).join(' · ') || 'Vehicule';

  return (
    <div
      className="bg-red-500/5 border border-red-500/20 rounded-xl p-4 space-y-2"
      data-testid={`${testIdPrefix}-card-${inspection?.id || 'unknown'}`}
    >
      {/* Header */}
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2 mb-0.5">
            <AlertTriangle size={14} className="text-red-400 shrink-0" />
            <span className="text-sm text-red-300 font-semibold truncate">{vehicleLabel}</span>
          </div>
          <div className="flex items-center gap-2 text-[11px] text-slate-400">
            <span>{inspection?.date || 'Date inconnue'}</span>
            {inspection?.driver_name && (
              <>
                <span className="text-slate-600">·</span>
                <span className="flex items-center gap-1"><User size={10} />{inspection.driver_name}</span>
              </>
            )}
            <span className="text-slate-600">·</span>
            <span className="text-red-400 font-medium">{defects.length} defaut(s)</span>
          </div>
        </div>
        {onCreateWorkOrder && (
          <button
            onClick={() => onCreateWorkOrder(inspection)}
            className="shrink-0 inline-flex items-center gap-1 bg-amber-500 hover:bg-amber-400 text-black text-[11px] font-bold px-2.5 py-1.5 rounded-lg transition-colors"
            data-testid={`${testIdPrefix}-create-order-${inspection?.id || 'unknown'}`}
          >
            <Wrench size={12} />
            Creer un bon
          </button>
        )}
      </div>

      {/* Defect list */}
      {defects.length > 0 && (
        <ul className="space-y-1 pt-1 border-t border-red-500/10">
          {defects.slice(0, 6).map((d, i) => (
            <li key={i} className="flex items-start gap-1.5 text-[12px]">
              <ChevronRight size={12} className="text-red-400 mt-0.5 shrink-0" />
              <div className="min-w-0">
                <span className="text-slate-200 font-medium">
                  {d.category && <span className="text-slate-500 uppercase text-[10px] mr-1">[{d.category}]</span>}
                  {d.item || d.name || 'Item'}
                </span>
                {(d.notes || d.note) && (
                  <span className="text-slate-400 italic"> — {d.notes || d.note}</span>
                )}
              </div>
            </li>
          ))}
          {defects.length > 6 && (
            <li className="text-[11px] text-slate-500 italic pl-4">... et {defects.length - 6} autre(s)</li>
          )}
        </ul>
      )}

      {/* General notes (bas du formulaire d'inspection) */}
      {inspection?.notes && (
        <div className="pt-2 border-t border-red-500/10">
          <p className="text-[11px] text-slate-500 font-semibold mb-1 uppercase tracking-wide">Remarques du chauffeur</p>
          <p className="text-[12px] text-slate-300 whitespace-pre-wrap">{inspection.notes}</p>
        </div>
      )}
    </div>
  );
};

export default FlaggedInspectionCard;
